import React from "react";
import "./FooterComponent.scss";
import { Typography } from "@mui/material";

interface FooterProps {
  variant?: "dashboard" | "public";
}

const FooterComponent: React.FC<FooterProps> = ({ variant = "dashboard" }) => {
  const footerLogo = require("../../../assets/img/the-b-logo.png");

  return (
    <footer className={`wary-footer ${variant === "dashboard" ? "wary-footer--dashboard" : "wary-footer--public"}`}>
      <div className="wary-footer__inner">
        <img src={footerLogo} alt="WARY" width={80} />
        <Typography variant="caption" color="text.secondary">
          &copy; {new Date().getFullYear()} The BAAR Company Pvt Ltd. All rights reserved.
        </Typography>
      </div>
    </footer>
  );
};

export { FooterComponent };
